import { createContext, useContext, useMemo } from 'react';
import { CardRenderContext } from '../render';
import { CardLayout, configByRenderContext } from './layoutConfigValues';

export const CardLayoutConfigContext = createContext<CardLayout>(configByRenderContext);

export function useLayoutConfig() {
  const config = useContext(CardLayoutConfigContext);
  const renderContext = useContext(CardRenderContext);

  return useMemo(() => config[renderContext], [config, renderContext]);
}
